import { render } from "./NewPassword.vue?vue&type=template&id=53eef521&scoped=true"
import script from "./NewPassword.vue?vue&type=script&lang=js"
export * from "./NewPassword.vue?vue&type=script&lang=js"

import "./NewPassword.vue?vue&type=style&index=0&id=53eef521&scoped=true&lang=css"

import exportComponent from "/home/learnbil/public_html/learnbilly.com/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53eef521"]])

export default __exports__